import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { DetailsLayout } from "components/akapBigas/detailsLayout";
import { useQrScannerContext } from "pages/QRScan/Context";
import { useParams } from "react-router-dom";
import { getTransactionDetails } from "services/merchant.service";
import { format, parseISO } from "date-fns";

const Container = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
`;

const DetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const MoneyContainer = styled.div`
  color: #000000;
  font-size: 20px;
  font-weight: 600;
`;

const MoneyDetails = styled.div`
  font-size: 12px;
  color: #000000;
  font-weight: 400;
`;

const ReferenceLabel = styled.div`
  color: #969696;
  font-size: 12px;
`;

const ReferenceValue = styled.div`
  color: #000000;
  font-size: 14px;
  font-weight: 700;
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 14px;
`;

const DateTimeContainer = styled.div`
  color: #4d4d4d;
  font-size: 12px;
  display: flex;
  margin-top: 25px;
  justify-content: center;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #969696;
  font-size: 16px;
`;

const TransactionDetails = () => {
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const { id } = useParams();
  const { user } = useQrScannerContext();

  useEffect(() => {
    const fetchTransactionDetails = async () => {
      if (id && user?.id) {
        try {
          setLoading(true);
          const details = await getTransactionDetails(user.id, id);
          setTransactionDetails(details);
        } catch (error) {
          console.error("Error fetching transaction details:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchTransactionDetails();
  }, [id, user?.id]);

  if (loading) {
    return (
      <DetailsLayout title="Transaction Details" isCloseButton={true}>
        <LoadingContainer>Loading transaction details...</LoadingContainer>
      </DetailsLayout>
    );
  }

  return (
    <DetailsLayout title="Transaction Details" isCloseButton={true}>
      <Container>
        <DetailsContainer>
          <div>
            <MoneyContainer>{transactionDetails?.overrides?.gross_total}</MoneyContainer>
            <MoneyDetails>{transactionDetails?.citizen?.name}</MoneyDetails>
          </div>
          <div>
            <ReferenceLabel>Reference Number</ReferenceLabel>
            <ReferenceValue>{transactionDetails?.id}</ReferenceValue>
          </div>
        </DetailsContainer>
        <DescriptionContainer></DescriptionContainer>
        <DateTimeContainer>
          <div>
            {transactionDetails?.created_at
              ? format(parseISO(transactionDetails.created_at), "MMM dd, yyyy h:mma")
              : "Date not available"}
          </div>
        </DateTimeContainer>
      </Container>
    </DetailsLayout>
  );
};

export default TransactionDetails;
